import React, { useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import HalfLayout from 'components/Layouts/Half'
import ActivatePage from 'pages/Activate'
import FoundPage from 'pages/Found'
import OrderRedemptionPage from 'pages/OrderRedemption'
import ErrorFallback from 'components/ErrorFallback'
import PromoCodeSignupPage from 'pages/PromoCodeSignup'

function is401Error(event: Sentry.Event, hint: Sentry.EventHint): boolean {
  const ex = hint?.originalException
  if (ex && typeof ex === 'object' && 'response' in ex) {
    const res = (ex as { response?: { status?: number } }).response
    if (res?.status === 401) return true
  }
  const msg = event.message ?? (ex instanceof Error ? ex.message : String(ex ?? ''))
  return typeof msg === 'string' && (msg.includes('401') || msg.includes('Unauthorized'))
}

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENV,
    sendDefaultPii: true,
    ignoreErrors: ['Network Error', 'Request failed with status code 401', 'Unauthorized', 'Failed to load Stripe.js'],
    beforeSend(event, hint) {
      if (is401Error(event, hint)) return null
      return event
    },
    integrations: [
      Sentry.replayIntegration({})
    ],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  })
}

function App() {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => <ErrorFallback error={error} />}
    >
      <Routes>
        <Route element={<HalfLayout />}>
          <Route path='/give/*' element={<OrderRedemptionPage />} />
          <Route path='/found/*' element={<FoundPage />} />
          <Route path='/redeem/*' element={<PromoCodeSignupPage />} />
          <Route path='/activate/*' element={<ActivatePage />} />
        </Route>
      </Routes>
    </Sentry.ErrorBoundary>
  )
}

export default App
